import { callApi } from './common'

function list(seq, category) {
  if (category) {
    return callApi(`billing/user_setting/${seq}/${category}`)
  }
  return callApi(`billing/user_setting/${seq}`)
}

function get(seq, category, name) {
  return callApi(
    `billing/user_setting/${seq}/${category}/${encodeURIComponent(name)}`
  )
}

function add(seq, category, data) {
  return callApi(`billing/user_setting/${seq}/${category}`, data, 'post')
}

function modify(seq, category, name, data) {
  return callApi(
    `billing/user_setting/${seq}/${category}/${encodeURIComponent(name)}`,
    { data },
    'put'
  )
}

function remove(seq, category, name) {
  if (name) {
    return callApi(
      `billing/user_setting/${seq}/${category}/${encodeURIComponent(name)}`,
      {},
      'delete'
    )
  }
  return callApi(`billing/user_setting/${seq}/${category}`, {}, 'delete')
}

export default {
  list,
  get,
  add,
  modify,
  remove,
}
